// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2TR0X","label":"styles_label__2RcJo"};